import { Stack, Text } from '@mantine/core';
import type { Shema } from '../api/odjemalec';
import { denar } from '../oblika/oblika';
import { Podatki } from '../postavitev/Podatki';

/** Razčlenitev izračuna DMV s strežnika (kot okno »Izračun DMV«). */
export function RazclenitevDmv({ izracun }: { izracun?: Shema['DmvIzracun'] }) {
  if (!izracun) {
    return null;
  }
  if (!izracun.izracunan) {
    return (
      <Text size="sm" c="dimmed" mt="sm">
        {izracun.sporocilo}
      </Text>
    );
  }
  return (
    <Stack gap={4} mt="md">
      <Text size="sm" fw={600}>
        Izračun ({izracun.vrstaDmv})
      </Text>
      <Podatki
        vrstice={[
          [
            izracun.upostevanCo2 ? `Po izpustu CO2 (${izracun.upostevanCo2} g/km)` : 'Po izpustu CO2',
            `${denar(izracun.poCo2)} €`,
          ],
          ['Po moči motorja', `${denar(izracun.poMoci)} €`],
          ['Po standardu EURO', `${denar(izracun.poEuro)} €`],
          ['Znižanje 30 %', `${denar(izracun.znizanje)} €`],
          ['Odstotek (rabljeno)', `${izracun.odstotek ?? 100} %`],
          ['Skupaj', <b key="s">{denar(izracun.skupaj)} €</b>],
        ]}
      />
      {izracun.opomba && (
        <Text size="sm" c="dimmed">
          {izracun.opomba}
        </Text>
      )}
    </Stack>
  );
}
